module.exports = __webpack_public_path__ + "img/logo-word.06db66c4.jpg";